
import Vue from "vue"

export default Vue.extend({
    props: ["data"],
    data() {
        return {
            activityCostData: { tableId: '', columns: [] } as { tableId: '', columns: { columnName: string; values: string[] }[] },
            search: "",
            actionFilter: "All",
            categoryFilter: "All",
            fields: [
                { key: 'Name', label: 'Activity' },
                { key: 'Duration', label: 'Plan Days', class: 'text-center' },
                { key: 'ActualDuration', label: 'Actual Days', class: 'text-center' },
            ],
        }
    },
    computed: {
        computedTableData(): Array<any> {
            const arr = [] as any[]
            if (!this.data.datasets.length) return arr
            for (let i = 0; i < this.data.datasets[0].data.length; i++) {
                arr.push({
                    Name: this.data.labels[i],
                    Duration: this.data.datasets[0].data[i],
                    ActualDuration: this.data.datasets[1].data[i]
                })
            }

            return arr
        }
    },
    methods: {
    },
    mounted() {
    },
    watch: {
    }
})
